export const makesResponseProcessor = (response) =>
  response?.data?.getMakesByPartialMatch?.map((make) => ({
    value: make.value,
    label: make.label,
    fleetApprovalStatus: make?.fleetStatus,
    NHTSApprovalStatus: make?.nhtsaStatus,
    nhtsaMakeCode: make?.nhtsaMakeCode,
  }));

export const modelsResponseProcessor = (response) =>
  response?.data?.getModelsByPartialMatch?.map((model) => ({
    value: model.value,
    label: model.label,
    fleetApprovalStatus: model?.fleetStatus,
    NHTSApprovalStatus: model?.nhtsaStatus,
    nhtsaModelCode: model?.nhtsaModelCode,
  }));
